import axios from 'axios';

/**
 * 后端 API 基础地址
 * 开发环境通过 Vite proxy 或直接访问后端
 * 生产环境通过同域反代
 */
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';

/** 创建 Axios 实例 */
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

/** 请求拦截器：自动携带 JWT */
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jwt_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

/** 响应拦截器：处理 401 跳转登录 */
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('jwt_token');
      localStorage.removeItem('user_info');
      // 避免在登录页循环跳转
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  },
);

export default api;
